import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";

const OrderBox = () => {
    return (
        <div className="order-box-wrapper xmt-4 xmt-lg-6">
            <div className="table-desktop d-none d-lg-block">
                <table className="table">
                    <thead className="table-header">
                    <tr>
                        <th scope="col">تاریخ ثبت سفارش</th>
                        <th scope="col">کد سفارش</th>
                        <th scope="col">مبلغ کل</th>
                        <th scope="col">وضعیت</th>
                        <th scope="col" className="details"><Link to="/orderDetails"> جزئیات<IconName name="chevron_left" className="icon"/></Link></th>
                    </tr>
                    </thead>
                    <tbody className="table-body">
                    <tr>
                        <td className="persian-number">۹ مرداد ۱۳۹۹</td>
                        <td>SD-64215567</td>
                        <td className="persian-number">۳۲,۴۰۸,۰۰۰ تومان‌</td>
                        <td colSpan="2" className="ok-payment"><IconName name="check_circle"
                                                                         className="icon"/>تایید شده
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="5" className="products-slider">
                            <div className="title xmb-6">مرسوله ۱ از ۱</div>
                            <div className="swiper order-box-swiper">
                                <div className="swiper-wrapper">
                                    <div className="swiper-slide">
                                        <div className="img"><img src="./assets/sample-image/157212.png" alt="image"/>
                                        </div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div className="img"><img
                                            src="./assets/sample-image/Deerma-Dust-Mite-Vacuum-Cleaner-CM1900-2.png"
                                            alt="image"/></div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div className="img"><img src="./assets/sample-image/unnamed (2).png"
                                                                  alt="image"/></div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div className="img"><img
                                            src="./assets/sample-image/Arundel_Evo Check smokey black_sku-header.png"
                                            alt="image"/></div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div className="img"><img
                                            src="./assets/sample-image/item_XL_38421821_149969411.png" alt="image"/>
                                        </div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div className="img"><img src="./assets/sample-image/unnamed333.png"
                                                                  alt="image"/></div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div className="img"><img src="./assets/sample-image/HN6K2.png" alt="image"/>
                                        </div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div className="img"><img
                                            src="./assets/sample-image/Xiaomi-Mi-Power-Bank-5000-mAh.png" alt="image"/>
                                        </div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div className="img"><img
                                            src="./assets/sample-image/38-alu-silver-sport-white-s3-1up_GEO_AU.png"
                                            alt="image"/></div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="5" className="show-factor"><a href="#" className="text">مشاهده فاکتور</a></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="table-responsive d-block d-lg-none">
                <ul className="list-unstyled">
                    <li className="info-order xpx-4 xpy-5">
                        <div className="item d-flex justify-content-between">
                            <span className="name">تاریخ ثبت سفارش</span>
                            <span className="value persian-number">۹ مرداد ۱۳۹۹</span>
                        </div>
                        <div className="item d-flex justify-content-between align-items-center">
                            <span className="name">کد سفارش</span>
                            <span className="value">SD-64215567</span>
                        </div>
                        <div className="item d-flex justify-content-between align-items-center">
                            <span className="name">مبلغ کل</span>
                            <span className="value persian-number">32,408,000 تومان</span>
                        </div>
                        <div className="item d-flex justify-content-between align-items-center">
                            <span className="name">وضعیت</span>
                            <span className="value green-value"><IconName name="check_circle"
                                                                             className="icon xml-1"/>تایید شده</span>
                        </div>
                    </li>
                    <li className="slider xpx-5 xpy-6">
                        <div className="title xmb-6">مرسوله ۱ از ۱</div>
                        <div className="swiper order-box-swiper">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <div className="img"><img src="./assets/sample-image/157212.png" alt="image"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="img"><img
                                        src="./assets/sample-image/Deerma-Dust-Mite-Vacuum-Cleaner-CM1900-2.png"
                                        alt="image"/></div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="img"><img src="./assets/sample-image/unnamed (2).png"
                                                              alt="image"/></div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="img"><img
                                        src="./assets/sample-image/Arundel_Evo Check smokey black_sku-header.png"
                                        alt="image"/></div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="img"><img
                                        src="./assets/sample-image/item_XL_38421821_149969411.png" alt="image"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="img"><img src="./assets/sample-image/unnamed333.png"
                                                              alt="image"/></div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="img"><img src="./assets/sample-image/HN6K2.png" alt="image"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="img"><img
                                        src="./assets/sample-image/Xiaomi-Mi-Power-Bank-5000-mAh.png" alt="image"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="img"><img
                                        src="./assets/sample-image/38-alu-silver-sport-white-s3-1up_GEO_AU.png"
                                        alt="image"/></div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li className="factor d-flex justify-content-between align-content-center xpy-4 xpx-5">
                        <a href="#" className="show-factor">مشاهده فاکتور</a>
                        <Link to="/orderDetails" className="details">جزئیات <IconName name="chevron_left" className="icon"/></Link>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default OrderBox;
